const React = require('react');
const AddressFields = require('components/addresses/address_fields.jsx');

class BillingAddressFields extends React.Component {
  render() {
    return (
      <AddressFields
        includePhoneInput={false}
        includeNameInput={false}
        includeSaveButton
        saveButtonText={I18n.t('js.creditCards.creditCardForm.saveCard')}
        addressTitle={I18n.t('js.creditCards.creditCardForm.billingAddress')}
        {...this.props}
      >
        {this.props.children}
      </AddressFields>
    );
  }
}

module.exports = BillingAddressFields;



// WEBPACK FOOTER //
// ./javascripts/components/addresses/billing_address_fields.jsx